import http from './request'

// 任务列表
export const refEarnTaskList = (data) => {
  return http({
    url: '/advertCenter/Order/getTaskList',
    method: 'post',
    data
  })
}

// 领取新手任务
export const grabRefEarnGuideTask = (data) => {
  return http({
    url: '/advertCenter/Task/receiveNewHandTask',
    method: 'post',
    data
  })
}

// 下级列表
export const getSubUserList = (data) => {
  return http({
    url: '/promotion/SubUserStat/getPagedList',
    method: 'post',
    data
  })
}

// 获取职位汇总信息
export const getUserPositionInfo = (data) => {
  return http({
    url: '/promotion/UserPosition/getInfo',
    method: 'post',
    data
  })
}

// 获取邀请人数和总佣金
export const getRefEarnAgentInfo = (data) => {
  return http({
    url: '/promotion/ReferralEarnActivityAgent/getInfo',
    method: 'post',
    data
  })
}

// 获取裂变任务裂变
export const getRefEarnAgentTasks = (data) => {
  return http({
    url: '/promotion/ReferralEarnActivityAgent/getTasks',
    method: 'post',
    data
  })
}

// 获取用户任务记录
export const getRefEarnNewbieTaskInfo = (data) => {
  return http({
    url: '/promotion/WaRecallActivityTaskRecord/getInfo',
    method: 'post',
    data
  })
}

export const getRefEarnDialogInfo = (data) => {
  return http({
    url: '/referralEarn/promotion/DialogInfo/getInfo',
    method: 'post',
    data
  })
}

export const getLuckyDrawShareTemplate = (data) => {
  return http({
    url: '/promotion/LuckyDraw/getShareTemplate',
    method: 'post',
    data
  })
}

// 获取高充返任务列表
export const getTopUpRewardProductList = (data) => {
  return http({
    url: '/promotion/TopUpReward/getProductList',
    method: 'post',
    data
  })
}
